import React from "react";

import Image from "@/components/common/image";
import { ImageSource } from "@/components/common/image/types";
import { toThumborWebp } from "@/utils/seo/thumbor";

import { AUTHOR_IMAGE_SIZE, AUTHOR_IMAGE_TARGET_WIDTH } from "./constants";
import { PersonsProps, StrapiImageFormats } from "./types";
import { pickImageByWidth } from "./utils";
import "./styles.scss";

const Persons = ({ author, expert }: PersonsProps) => {
  // Оригинал аватара из Strapi бывает мегабайтным (проверено на проде: 2.5 МБ на бокс 104×104),
  // поэтому берём уменьшенную копию, а webp отдаём через Thumbor (null при выключенном флаге).
  const authorImageUrl = pickImageByWidth(
    author?.image?.formats as StrapiImageFormats | null,
    author?.image?.url ?? "",
    AUTHOR_IMAGE_TARGET_WIDTH,
  );
  const authorImageWebp = authorImageUrl ? toThumborWebp(authorImageUrl, AUTHOR_IMAGE_TARGET_WIDTH) : null;
  const authorImageSources: ImageSource[] | undefined = authorImageWebp
    ? [{ srcSet: authorImageWebp, type: "image/webp" }]
    : undefined;

  return (
    <div className="seo-persons">
      {author && (
      <div className="seo-article__person">
        <div className="seo-persons__person-title">Автор статьи</div>
        <div className="seo-persons__person-card">
          <div className="seo-persons__person-card-left">
            <Image
              src={authorImageUrl}
              alt={author.name}
              width={AUTHOR_IMAGE_SIZE}
              height={AUTHOR_IMAGE_SIZE}
              sources={authorImageSources}
            />
          </div>
          <div className="seo-persons__person-card-right">
            <div className="seo-persons__person-name">
              {author.name}
            </div>
            <div className="seo-persons__person-description">{author.description}</div>
          </div>
        </div>
      </div>
      )}
      {/* {expert && (
        <div className="seo-persons__person">
          <div className="seo-persons__person-title">Эксперт статьи</div>
          <div className="seo-persons__person-card">
            <div className="seo-persons__person-card-left">
              <img src={expert.smallImage} alt="" />
            </div>
            <div className="seo-persons__person-card-right">
              <div className="seo-persons__person-name">
                <Link to={`/expert/${20}`}>{expert.name}</Link>
              </div>
              <div className="seo-persons__person-info">
                <Rating value={expert.rating} />
                <div className="seo-persons__person-skills">
                  {capitalize(
                    (expert.skills ?? []).map((skill) =>
                      skill.badge)
                      .join(", "),
                  )}
                </div>
              </div>
              <div className="seo-persons__person-status"><ExpertStatus status={expertStatus} /></div>
            </div>
          </div>
        </div>
      )} */}
    </div>
  );
};

export default Persons;
